<script>
function passwordMeetsPolicy(pw) {
  if (!pw || pw.length < 8) {
    return "รหัสผ่านต้องมีความยาวอย่างน้อย 8 ตัวอักษร";
  }
  if (!/[0-9]/.test(pw)) {
    return "รหัสผ่านต้องมีตัวเลขอย่างน้อย 1 ตัว";
  }
  if (!/[A-Z]/.test(pw)) {
    return "รหัสผ่านต้องมีตัวอักษรภาษาอังกฤษพิมพ์ใหญ่";
  }
  if (!/[a-z]/.test(pw)) {
    return "รหัสผ่านต้องมีตัวอักษรภาษาอังกฤษพิมพ์เล็ก";
  }
  if (!/[^A-Za-z0-9]/.test(pw)) {
    return "รหัสผ่านต้องมีอักขระพิเศษอย่างน้อย 1 ตัว";
  }
  return "";
}

function parseJsonResponse(res) {
  return res.text().then(function (text) {
    var data = {};
    try {
      data = text ? JSON.parse(text) : {};
    } catch (err) {
      data = { success: false, message: text || "API response ไม่ถูกต้อง" };
    }
    if (!res.ok) {
      throw new Error(data.message || "Request failed");
    }
    return data;
  });
}

function emptyUserForm() {
  return {
    id: "",
    full_name: "",
    email: "",
    role: "",
    status: "",
    passwordMode: "auto",
    password: "",
    passwordConfirm: "",
  };
}

export default {
  name: "AdminUsers",
  props: {
    config: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data: function () {
    var cfg = this.config || {};
    var users = Array.isArray(cfg.users) ? cfg.users.slice() : [];
    var auditLogs = Array.isArray(cfg.auditLogs) ? cfg.auditLogs.slice() : [];
    return {
      users: users,
      auditLogs: auditLogs,
      dbError: String(cfg.dbError || ""),
      search: "",
      page: 1,
      perPage: 5,
      stats: {
        total: Number(cfg.userCountTotal || users.length) || 0,
        online: Number(cfg.userCountOnline || 0) || 0,
        pending: Number(cfg.userCountPending || 0) || 0,
        suspended: Number(cfg.userCountSuspended || 0) || 0,
      },
      alert: { type: "", message: "", generatedPassword: "" },
      formMode: "create",
      form: emptyUserForm(),
      saving: false,
      reset: { userId: "", display: "", passwordMode: "auto", password: "", passwordConfirm: "" },
      resetting: false,
      deleteTarget: null,
      deleting: false,
      statusFilter: "",
      queueBusyId: "",
    };
  },
  computed: {
    roleOptions: function () {
      var raw = (this.config && this.config.roleOptions) || [];
      var list = Array.isArray(raw) ? raw.slice() : [];
      var current = String((this.form && this.form.role) || "").trim();
      if (current && list.indexOf(current) === -1) {
        list = [current].concat(list);
      }
      return list;
    },
    statusOptions: function () {
      var raw = (this.config && this.config.statusOptions) || [];
      var list = Array.isArray(raw) && raw.length ? raw.slice() : ["Active", "Pending", "Suspended"];
      var current = String((this.form && this.form.status) || "").trim();
      if (current && list.indexOf(current) === -1) {
        list = [current].concat(list);
      }
      return list;
    },
    createUrl: function () {
      return String((this.config && this.config.createUrl) || "actions/admin/user-create.php");
    },
    updateUrl: function () {
      return String((this.config && this.config.updateUrl) || "actions/admin/user-update.php");
    },
    deleteUrl: function () {
      return String((this.config && this.config.deleteUrl) || "actions/admin/user-delete.php");
    },
    resetUrl: function () {
      return String((this.config && this.config.resetUrl) || "actions/admin/user-reset-password.php");
    },
    setStatusUrl: function () {
      return String((this.config && this.config.setStatusUrl) || "actions/admin/user-set-status.php");
    },
    currentUserId: function () {
      return String((this.config && this.config.currentUserId) || "");
    },
    currentUserEmail: function () {
      return String((this.config && this.config.currentUserEmail) || "").trim().toLowerCase();
    },
    filteredUsers: function () {
      var q = String(this.search || "").trim().toLowerCase();
      var filter = String(this.statusFilter || "").trim().toLowerCase();
      var rows = this.users || [];
      return rows.filter(function (row) {
        var status = String(row.status || "").trim().toLowerCase();
        if (filter === "pending" && status !== "pending") {
          return false;
        }
        if (filter === "suspended") {
          if (["suspended", "inactive", "disabled"].indexOf(status) === -1) {
            return false;
          }
        }
        if (!q) {
          return true;
        }
        return [
          row.id,
          row.full_name,
          row.email,
          row.role,
          row.status,
          row.last_login,
        ]
          .join(" ")
          .toLowerCase()
          .indexOf(q) !== -1;
      });
    },
    totalPages: function () {
      return Math.max(1, Math.ceil(this.filteredUsers.length / this.perPage));
    },
    pagedUsers: function () {
      var start = (this.page - 1) * this.perPage;
      return this.filteredUsers.slice(start, start + this.perPage);
    },
    nextUserCode: function () {
      var maxNo = 0;
      (this.users || []).forEach(function (row) {
        var m = String(row.id || "")
          .trim()
          .toUpperCase()
          .match(/^U(\d+)$/);
        if (m) {
          var n = parseInt(m[1], 10);
          if (!isNaN(n) && n > maxNo) {
            maxNo = n;
          }
        }
      });
      return "U" + String(maxNo + 1).padStart(4, "0");
    },
    passwordFeedback: function () {
      if (this.formMode !== "create" || this.form.passwordMode === "auto") {
        return { text: "", tone: "" };
      }
      return this.pairFeedback(this.form.password, this.form.passwordConfirm);
    },
    resetPasswordFeedback: function () {
      if (this.reset.passwordMode === "auto") {
        return { text: "", tone: "" };
      }
      return this.pairFeedback(this.reset.password, this.reset.passwordConfirm);
    },
    pageNumbers: function () {
      var start = Math.max(1, this.page - 2);
      var end = Math.min(this.totalPages, start + 4);
      start = Math.max(1, end - 4);
      var nums = [];
      var i;
      for (i = start; i <= end; i++) {
        nums.push(i);
      }
      return nums;
    },
  },
  watch: {
    search: function () {
      this.page = 1;
    },
  },
  methods: {
    pairFeedback: function (pwd, pwd2) {
      pwd = String(pwd || "");
      pwd2 = String(pwd2 || "");
      if (!pwd && !pwd2) {
        return { text: "", tone: "" };
      }
      var err = passwordMeetsPolicy(pwd);
      if (err) {
        return { text: err, tone: "danger" };
      }
      if (pwd && pwd2 && pwd !== pwd2) {
        return { text: "รหัสผ่านและยืนยันรหัสผ่านไม่ตรงกัน", tone: "danger" };
      }
      if (pwd && pwd2 && pwd === pwd2) {
        return { text: "รหัสผ่านผ่านเงื่อนไขและตรงกับช่องยืนยันแล้ว", tone: "success" };
      }
      return { text: "รหัสผ่านผ่านเงื่อนไขแล้ว กรุณายืนยันรหัสผ่าน", tone: "muted" };
    },
    lastLoginText: function (row) {
      var t = String((row && row.last_login) || "").trim();
      return t === "" ? "ยังไม่มีการ login เข้าสู่ระบบ" : t;
    },
    isSuperAdminName: function (name) {
      return String(name || "").replace(/\s+/g, "").toLowerCase() === "superadmin";
    },
    isSelfUser: function (row) {
      var id = String((row && row.id) || "");
      var email = String((row && row.email) || "").trim().toLowerCase();
      if (this.currentUserId !== "" && id !== "" && String(this.currentUserId) === id) {
        return true;
      }
      if (this.currentUserEmail !== "" && email !== "" && this.currentUserEmail === email) {
        return true;
      }
      return false;
    },
    isLastSuperAdmin: function (row) {
      if (!this.isSuperAdminName(row && row.role)) {
        return false;
      }
      var count = 0;
      var users = this.users || [];
      var i;
      for (i = 0; i < users.length; i++) {
        if (this.isSuperAdminName(users[i].role)) {
          count++;
        }
      }
      return count <= 1;
    },
    canDeleteUser: function (row) {
      return !!row && !this.isSelfUser(row) && !this.isLastSuperAdmin(row);
    },
    isPendingUser: function (row) {
      return String((row && row.status) || "").trim().toLowerCase() === "pending";
    },
    setStatusFilter: function (key) {
      this.statusFilter = this.statusFilter === key ? "" : key;
      this.page = 1;
    },
    adjustStatusStats: function (fromStatus, toStatus) {
      var from = String(fromStatus || "").trim().toLowerCase();
      var to = String(toStatus || "").trim().toLowerCase();
      if (from === "pending") {
        this.stats.pending = Math.max(0, this.stats.pending - 1);
      }
      if (["suspended", "inactive", "disabled"].indexOf(from) !== -1) {
        this.stats.suspended = Math.max(0, this.stats.suspended - 1);
      }
      if (to === "pending") {
        this.stats.pending += 1;
      }
      if (["suspended", "inactive", "disabled"].indexOf(to) !== -1) {
        this.stats.suspended += 1;
      }
    },
    decideUser: function (row, decision) {
      var self = this;
      if (!row || !row.id || this.queueBusyId) {
        return;
      }
      if (decision === "reject" && !window.confirm("ยืนยันไม่อนุมัติผู้ใช้นี้? บัญชีจะถูกระงับและเข้าสู่ระบบไม่ได้")) {
        return;
      }
      this.queueBusyId = String(row.id);
      var body = new FormData();
      body.append("user_id", String(row.id));
      body.append("decision", decision);
      fetch(this.setStatusUrl, { method: "POST", body: body, credentials: "same-origin" })
        .then(parseJsonResponse)
        .then(function (data) {
          if (!data || data.success !== true) {
            throw new Error((data && data.message) || "อัปเดตสถานะไม่สำเร็จ");
          }
          var nextStatus = String(data.status || (decision === "approve" ? "Active" : "Suspended"));
          self.adjustStatusStats(row.status, nextStatus);
          self.users = self.users.map(function (item) {
            if (String(item.id) !== String(row.id)) {
              return item;
            }
            return Object.assign({}, item, { status: nextStatus });
          });
          self.prependAudit(data.audit);
          self.showAlert("success", data.message || "อัปเดตสถานะสำเร็จ");
        })
        .catch(function (err) {
          self.showAlert("danger", err.message || "เกิดข้อผิดพลาดในการพิจารณาผู้ใช้");
        })
        .finally(function () {
          self.queueBusyId = "";
        });
    },
    deleteBlockReason: function (row) {
      if (this.isSelfUser(row)) {
        return "ไม่สามารถลบบัญชีที่กำลังเข้าสู่ระบบอยู่";
      }
      if (this.isLastSuperAdmin(row)) {
        return "ไม่สามารถลบ Super Admin คนสุดท้ายในระบบ";
      }
      return "";
    },
    statusClass: function (status) {
      var n = String(status || "").trim().toLowerCase();
      if (n === "active") {
        return "bg-success-subtle text-success";
      }
      if (n === "pending") {
        return "bg-warning-subtle text-warning";
      }
      return "bg-danger-subtle text-danger";
    },
    showAlert: function (type, message, generatedPassword) {
      this.alert = {
        type: type === "success" ? "success" : "danger",
        message: String(message || ""),
        generatedPassword: String(generatedPassword || ""),
      };
    },
    prependAudit: function (row) {
      if (!row || typeof row !== "object") {
        return;
      }
      var item = {
        id: String(row.id || Date.now()),
        created_at: String(row.created_at || ""),
        actor_user_id: String(row.actor_user_id || ""),
        actor_email: String(row.actor_email || ""),
        actor_name: String(row.actor_name || row.actor_email || ""),
        action: String(row.action || ""),
        action_label: String(row.action_label || row.action || ""),
        target_type: String(row.target_type || ""),
        target_id: String(row.target_id || ""),
        target_label: String(row.target_label || ""),
        summary: String(row.summary || ""),
        ip: String(row.ip || ""),
      };
      this.auditLogs = [item].concat(this.auditLogs).slice(0, 100);
    },
    formatAuditTime: function (raw) {
      var t = String(raw || "").trim();
      if (!t) {
        return "—";
      }
      var ts = Date.parse(t.replace(" ", "T"));
      if (isNaN(ts)) {
        return t;
      }
      var d = new Date(ts);
      var pad = function (n) {
        return String(n).padStart(2, "0");
      };
      return pad(d.getDate()) + "/" + pad(d.getMonth() + 1) + "/" + d.getFullYear() + " " + pad(d.getHours()) + ":" + pad(d.getMinutes());
    },
    showModal: function (refName) {
      var el = this.$refs[refName];
      if (!el || !window.bootstrap || !window.bootstrap.Modal) {
        return;
      }
      window.bootstrap.Modal.getOrCreateInstance(el).show();
    },
    hideModal: function (refName) {
      var el = this.$refs[refName];
      var inst;
      if (!el || !window.bootstrap || !window.bootstrap.Modal) {
        return;
      }
      inst = window.bootstrap.Modal.getInstance(el);
      if (inst) {
        inst.hide();
      }
    },
    openCreate: function () {
      this.formMode = "create";
      this.form = emptyUserForm();
      this.form.id = this.nextUserCode;
      this.form.passwordMode = "auto";
      this.showModal("userModal");
    },
    openEdit: function (row) {
      this.formMode = "edit";
      this.form = {
        id: String(row.id || ""),
        full_name: String(row.full_name || ""),
        email: String(row.email || ""),
        role: String(row.role || ""),
        status: String(row.status || ""),
        passwordMode: "auto",
        password: "",
        passwordConfirm: "",
      };
      this.showModal("userModal");
    },
    openReset: function (row) {
      this.reset = {
        userId: String(row.id || ""),
        display: String(row.id || "") + (row.full_name ? " — " + row.full_name : ""),
        passwordMode: "auto",
        password: "",
        passwordConfirm: "",
      };
      this.showModal("resetModal");
    },
    openDelete: function (row) {
      if (!this.canDeleteUser(row)) {
        this.showAlert("danger", this.deleteBlockReason(row));
        return;
      }
      this.deleteTarget = row;
      this.showModal("deleteModal");
    },
    saveUser: function () {
      var self = this;
      var form = this.form;
      var id = String(form.id || "").trim();
      var name = String(form.full_name || "").trim();
      var email = String(form.email || "").trim();
      var role = String(form.role || "").trim();
      var status = String(form.status || "").trim();
      if (!id || !name || !email || !role || !status) {
        this.showAlert("danger", "กรุณากรอกข้อมูลให้ครบถ้วน");
        return;
      }
      var emailLower = email.toLowerCase();
      var emailTaken = this.users.some(function (row) {
        if (self.formMode === "edit" && String(row.id) === id) {
          return false;
        }
        return String(row.email || "").trim().toLowerCase() === emailLower;
      });
      if (emailTaken) {
        this.showAlert("danger", "อีเมลนี้มีในระบบแล้ว");
        return;
      }
      if (this.formMode === "edit") {
        var existing = null;
        this.users.forEach(function (row) {
          if (String(row.id) === id) {
            existing = row;
          }
        });
        if (existing && this.isLastSuperAdmin(existing)) {
          if (!this.isSuperAdminName(role)) {
            this.showAlert("danger", "ไม่สามารถเปลี่ยนบทบาท Super Admin คนสุดท้ายในระบบ");
            return;
          }
          if (["pending", "suspended", "inactive", "disabled"].indexOf(status.toLowerCase()) !== -1) {
            this.showAlert("danger", "ไม่สามารถระงับหรือปิด Super Admin คนสุดท้ายในระบบ");
            return;
          }
        }
      }
      if (this.formMode === "create" && form.passwordMode !== "auto") {
        var err = passwordMeetsPolicy(form.password);
        if (err) {
          return;
        }
        if (form.password !== form.passwordConfirm) {
          return;
        }
      }
      this.saving = true;
      var body = new FormData();
      body.append("user_id", id);
      body.append("full_name", name);
      body.append("email", email);
      body.append("role", role);
      body.append("status", status);
      var url = this.updateUrl;
      if (this.formMode === "create") {
        url = this.createUrl;
        body.append("password_mode", form.passwordMode === "auto" ? "auto" : "manual");
        if (form.passwordMode !== "auto") {
          body.append("password", form.password);
        }
      }
      fetch(url, { method: "POST", body: body, credentials: "same-origin" })
        .then(parseJsonResponse)
        .then(function (data) {
          if (!data || data.success !== true) {
            throw new Error((data && data.message) || "บันทึกไม่สำเร็จ");
          }
          if (self.formMode === "edit") {
            var oldStatus = "";
            self.users.forEach(function (row) {
              if (String(row.id) === id) {
                oldStatus = String(row.status || "");
              }
            });
            self.adjustStatusStats(oldStatus, status);
            self.users = self.users.map(function (row) {
              if (String(row.id) !== id) {
                return row;
              }
              return Object.assign({}, row, { full_name: name, email: email, role: role, status: status });
            });
            self.hideModal("userModal");
            self.prependAudit(data.audit);
            self.showAlert("success", data.message || "แก้ไขผู้ใช้งานสำเร็จ");
            return;
          }
          self.users = self.users.concat([
            { id: id, full_name: name, email: email, role: role, status: status, last_login: "" },
          ]);
          self.stats.total += 1;
          self.adjustStatusStats("", status);
          self.hideModal("userModal");
          self.prependAudit(data.audit);
          self.showAlert("success", data.message || "เพิ่มผู้ใช้งานสำเร็จ", data.generated_password || "");
        })
        .catch(function (err) {
          self.showAlert("danger", err.message || "เกิดข้อผิดพลาดในการบันทึก");
        })
        .finally(function () {
          self.saving = false;
        });
    },
    submitReset: function () {
      var self = this;
      var uid = String(this.reset.userId || "").trim();
      if (!uid) {
        return;
      }
      if (this.reset.passwordMode !== "auto") {
        if (passwordMeetsPolicy(this.reset.password) || this.reset.password !== this.reset.passwordConfirm) {
          return;
        }
      }
      this.resetting = true;
      var body = new FormData();
      body.append("user_id", uid);
      body.append("password_mode", this.reset.passwordMode === "auto" ? "auto" : "manual");
      if (this.reset.passwordMode !== "auto") {
        body.append("password", this.reset.password);
      }
      fetch(this.resetUrl, { method: "POST", body: body, credentials: "same-origin" })
        .then(parseJsonResponse)
        .then(function (data) {
          if (!data || data.success !== true) {
            throw new Error((data && data.message) || "ไม่สามารถรีเซ็ตรหัสผ่านได้");
          }
          self.hideModal("resetModal");
          self.prependAudit(data.audit);
          self.showAlert("success", data.message || "รีเซ็ตรหัสผ่านสำเร็จ", data.generated_password || "");
        })
        .catch(function (err) {
          self.showAlert("danger", err.message || "เกิดข้อผิดพลาดในการรีเซ็ตรหัสผ่าน");
        })
        .finally(function () {
          self.resetting = false;
        });
    },
    confirmDelete: function () {
      var self = this;
      var row = this.deleteTarget;
      if (!row || !row.id) {
        return;
      }
      this.deleting = true;
      var body = new FormData();
      body.append("user_id", String(row.id));
      fetch(this.deleteUrl, { method: "POST", body: body, credentials: "same-origin" })
        .then(parseJsonResponse)
        .then(function (data) {
          if (!data || data.success !== true) {
            throw new Error((data && data.message) || "ไม่สามารถลบผู้ใช้งานได้");
          }
          self.users = self.users.filter(function (item) {
            return String(item.id) !== String(row.id);
          });
          self.stats.total = Math.max(0, self.stats.total - 1);
          self.adjustStatusStats(row.status, "");
          self.deleteTarget = null;
          self.hideModal("deleteModal");
          self.prependAudit(data.audit);
          self.showAlert("success", data.message || "ลบผู้ใช้งานสำเร็จ");
        })
        .catch(function (err) {
          self.showAlert("danger", err.message || "เกิดข้อผิดพลาดในการลบข้อมูล");
        })
        .finally(function () {
          self.deleting = false;
        });
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-sm-flex align-items-center justify-content-between bg-galaxy-transparent">
          <h4 class="mb-sm-0">จัดการผู้ใช้งาน</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript:void(0);">ผู้ดูแลระบบ</a></li>
              <li class="breadcrumb-item active">จัดการผู้ใช้งาน</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-3 col-md-6">
        <div class="card card-animate" role="button" tabindex="0" :class="{ 'border-primary': statusFilter === '' }" @click="setStatusFilter('')">
          <div class="card-body">
            <p class="text-uppercase fw-medium text-muted mb-0">ผู้ใช้งานทั้งหมด</p>
            <h4 class="mt-3 mb-0">{{ stats.total }} คน</h4>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-md-6">
        <div class="card card-animate">
          <div class="card-body">
            <p class="text-uppercase fw-medium text-muted mb-0">ผู้ใช้งานออนไลน์</p>
            <h4 class="mt-3 mb-0 text-success">{{ stats.online }} คน</h4>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-md-6">
        <div class="card card-animate" role="button" tabindex="0" :class="{ 'border-warning': statusFilter === 'pending' }" @click="setStatusFilter('pending')">
          <div class="card-body">
            <p class="text-uppercase fw-medium text-muted mb-0">รออนุมัติ</p>
            <h4 class="mt-3 mb-0 text-warning">{{ stats.pending }} คน</h4>
            <div class="small text-muted mt-1">คลิกเพื่อเปิดคิวอนุมัติ</div>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-md-6">
        <div class="card card-animate" role="button" tabindex="0" :class="{ 'border-danger': statusFilter === 'suspended' }" @click="setStatusFilter('suspended')">
          <div class="card-body">
            <p class="text-uppercase fw-medium text-muted mb-0">ถูกระงับ</p>
            <h4 class="mt-3 mb-0 text-danger">{{ stats.suspended }} คน</h4>
          </div>
        </div>
      </div>
    </div>

    <div v-if="alert.message" class="alert alert-dismissible fade show material-shadow" :class="alert.type === 'success' ? 'alert-success' : 'alert-danger'" role="alert">
      {{ alert.message }}
      <template v-if="alert.generatedPassword">
        รหัสผ่านชั่วคราวที่สร้างให้: <strong>{{ alert.generatedPassword }}</strong> (โปรดแจ้งผู้ใช้และให้เปลี่ยนรหัสหลังเข้าระบบ)
      </template>
      <button type="button" class="btn-close" aria-label="Close" @click="alert.message = ''"></button>
    </div>
    <div v-if="dbError" class="alert alert-danger" role="alert">{{ dbError }}</div>

    <div class="card">
      <div class="card-header">
        <h4 class="card-title mb-1">ตารางจัดการผู้ใช้งานระบบ</h4>
        <p class="text-muted mb-0">ใช้สำหรับเพิ่ม แก้ไข ค้นหา และลบข้อมูลผู้ใช้งานในระบบผู้ดูแล</p>
        <div v-if="statusFilter === 'pending'" class="alert alert-warning mt-3 mb-0 py-2">
          คิวอนุมัติ — บัญชี Pending ยังเข้าสู่ระบบไม่ได้ จนกว่าจะกดอนุมัติ
        </div>
      </div>
      <div class="card-body">
        <div class="row g-4 mb-3">
          <div class="col-sm-auto">
            <button type="button" class="btn btn-success add-btn" @click="openCreate">
              <i class="ri-add-line align-bottom me-1"></i> Add
            </button>
          </div>
          <div class="col-sm">
            <div class="d-flex justify-content-sm-end">
              <div class="search-box ms-2">
                <input v-model="search" type="text" class="form-control search" placeholder="Search...">
                <i class="ri-search-line search-icon"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="table-responsive table-card mt-3 mb-1">
          <table class="table align-middle table-nowrap">
            <thead class="table-light">
              <tr>
                <th>รหัส</th>
                <th>ชื่อผู้ใช้งาน</th>
                <th>อีเมล</th>
                <th>บทบาท</th>
                <th>สถานะ</th>
                <th>เข้าสู่ระบบล่าสุด</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="pagedUsers.length === 0">
                <td colspan="7" class="text-muted">{{ search ? "ไม่พบรายการผู้ใช้งานตามคำค้นหา" : "ไม่พบข้อมูลผู้ใช้งานในฐานข้อมูล" }}</td>
              </tr>
              <tr v-for="row in pagedUsers" :key="row.id">
                <td>{{ row.id }}</td>
                <td>{{ row.full_name }}</td>
                <td>{{ row.email }}</td>
                <td>{{ row.role }}</td>
                <td>
                  <span class="badge text-uppercase" :class="statusClass(row.status)">{{ row.status }}</span>
                </td>
                <td>{{ lastLoginText(row) }}</td>
                <td>
                  <div class="d-flex gap-2 flex-wrap">
                    <template v-if="isPendingUser(row)">
                      <button type="button" class="btn btn-sm btn-success" :disabled="queueBusyId === String(row.id)" @click="decideUser(row, 'approve')">อนุมัติ</button>
                      <button type="button" class="btn btn-sm btn-outline-danger" :disabled="queueBusyId === String(row.id)" @click="decideUser(row, 'reject')">ไม่อนุมัติ</button>
                    </template>
                    <button type="button" class="btn btn-sm btn-warning" @click="openReset(row)">Reset password</button>
                    <button type="button" class="btn btn-sm btn-success" @click="openEdit(row)">Edit</button>
                    <button type="button" class="btn btn-sm btn-danger" :disabled="!canDeleteUser(row)" :title="deleteBlockReason(row)" @click="openDelete(row)">Remove</button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="totalPages > 1" class="d-flex justify-content-end">
          <div class="pagination-wrap hstack gap-2">
            <button type="button" class="btn btn-sm btn-light" :disabled="page <= 1" @click="page = page - 1">Previous</button>
            <button
              v-for="n in pageNumbers"
              :key="n"
              type="button"
              class="btn btn-sm"
              :class="n === page ? 'btn-primary' : 'btn-light'"
              @click="page = n"
            >{{ n }}</button>
            <button type="button" class="btn btn-sm btn-light" :disabled="page >= totalPages" @click="page = page + 1">Next</button>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-header">
        <h4 class="card-title mb-0">ประวัติการกระทำ</h4>
        <p class="text-muted mb-0 mt-1">บันทึกการสร้าง แก้ไข ลบ และรีเซ็ตรหัสผ่านของผู้ใช้ รวมถึงการจัดการบทบาท — ไม่เก็บรหัสผ่าน</p>
      </div>
      <div class="card-body">
        <div class="table-responsive table-card">
          <table class="table table-nowrap align-middle mb-0">
            <thead class="table-light text-muted">
              <tr>
                <th>เวลา</th>
                <th>ผู้ทำ</th>
                <th>การกระทำ</th>
                <th>เป้าหมาย</th>
                <th>รายละเอียด</th>
                <th>IP</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="auditLogs.length === 0">
                <td colspan="6" class="text-muted">ยังไม่มีบันทึก — จะปรากฏเมื่อมีการสร้าง แก้ ลบ หรือรีเซ็ตรหัส</td>
              </tr>
              <tr v-for="row in auditLogs" :key="row.id">
                <td class="text-nowrap">{{ formatAuditTime(row.created_at) }}</td>
                <td>
                  <div>{{ row.actor_name || "—" }}</div>
                  <div class="small text-muted">{{ row.actor_email }}</div>
                </td>
                <td><span class="badge bg-info-subtle text-info">{{ row.action_label || row.action }}</span></td>
                <td class="text-wrap">{{ row.target_label || row.target_id || "—" }}</td>
                <td class="text-wrap">{{ row.summary }}</td>
                <td class="text-nowrap">{{ row.ip || "—" }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="modal fade" ref="userModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-light p-3">
            <h5 class="modal-title">{{ formMode === "edit" ? "แก้ไขผู้ใช้งาน" : "เพิ่มผู้ใช้งาน" }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form autocomplete="off" @submit.prevent="saveUser">
            <div class="modal-body">
              <div class="mb-3">
                <label class="form-label" for="mct-admin-user-id">รหัสผู้ใช้งาน</label>
                <input id="mct-admin-user-id" v-model="form.id" type="text" class="form-control" readonly required>
              </div>
              <div class="mb-3">
                <label class="form-label" for="mct-admin-user-name">ชื่อผู้ใช้งาน</label>
                <input id="mct-admin-user-name" v-model="form.full_name" type="text" class="form-control" placeholder="กรอกชื่อผู้ใช้งาน" required>
              </div>
              <div class="mb-3">
                <label class="form-label" for="mct-admin-user-email">อีเมล</label>
                <input id="mct-admin-user-email" v-model="form.email" type="email" class="form-control" placeholder="กรอกอีเมล" required>
              </div>
              <div v-if="formMode === 'create'" class="mb-3">
                <label class="form-label d-block">รหัสผ่าน (สำหรับเพิ่มผู้ใช้ใหม่)</label>
                <div class="form-check mb-2">
                  <input id="mct-admin-pwd-auto" v-model="form.passwordMode" class="form-check-input" type="radio" value="auto">
                  <label class="form-check-label" for="mct-admin-pwd-auto">สร้างรหัสผ่านโดยอัตโนมัติ</label>
                </div>
                <div class="form-check mb-3">
                  <input id="mct-admin-pwd-manual" v-model="form.passwordMode" class="form-check-input" type="radio" value="manual">
                  <label class="form-check-label" for="mct-admin-pwd-manual">กำหนดรหัสผ่านเอง</label>
                </div>
                <div v-if="form.passwordMode === 'manual'">
                  <input v-model="form.password" type="password" class="form-control mb-2" placeholder="รหัสผ่าน" autocomplete="new-password" required>
                  <input v-model="form.passwordConfirm" type="password" class="form-control" placeholder="ยืนยันรหัสผ่าน" autocomplete="new-password" required>
                </div>
                <p v-if="passwordFeedback.text" class="form-text mb-0 mt-2" :class="'text-' + passwordFeedback.tone">{{ passwordFeedback.text }}</p>
                <p v-if="form.passwordMode === 'manual'" class="form-text mb-0 mt-2">
                  <span class="fw-medium">เงื่อนไขรหัสผ่าน (เมื่อกำหนดเอง):</span>
                  ความยาวอย่างน้อย 8 ตัวอักษร ต้องประกอบด้วยตัวเลข ตัวอักษรภาษาอังกฤษพิมพ์ใหญ่ พิมพ์เล็ก และอักขระพิเศษ (เช่น <code>!@#$%^&amp;*()</code>)
                </p>
                <p v-else class="form-text text-muted mb-0 mt-1">ระบบจะสร้างรหัสผ่านที่ผ่านเงื่อนไขให้อัตโนมัติ หลังบันทึกสำเร็จจะแสดงรหัสชั่วคราวให้คัดลอกแจ้งผู้ใช้</p>
              </div>
              <div class="mb-3">
                <label class="form-label" for="mct-admin-user-role">บทบาท</label>
                <select id="mct-admin-user-role" v-model="form.role" class="form-select" required>
                  <option value="">เลือกบทบาท</option>
                  <option v-for="opt in roleOptions" :key="opt" :value="opt">{{ opt }}</option>
                </select>
              </div>
              <div>
                <label class="form-label" for="mct-admin-user-status">สถานะ</label>
                <select id="mct-admin-user-status" v-model="form.status" class="form-select" required>
                  <option value="">เลือกสถานะ</option>
                  <option v-for="opt in statusOptions" :key="opt" :value="opt">{{ opt }}</option>
                </select>
                <div class="form-text">Pending = ยังเข้าสู่ระบบไม่ได้จนกว่าจะอนุมัติจากคิวด้านบน</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
              <button type="submit" class="btn btn-success" :disabled="saving">{{ saving ? "กำลังบันทึก..." : "Save" }}</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="modal fade" ref="resetModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-light p-3">
            <h5 class="modal-title">รีเซ็ตรหัสผ่าน</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form autocomplete="off" @submit.prevent="submitReset">
            <div class="modal-body">
              <p class="text-muted mb-0 pb-3 border-bottom">
                <span class="fw-medium text-body">ผู้ใช้งาน:</span> {{ reset.display }}
              </p>
              <div class="mt-3">
                <label class="form-label d-block">ตั้งรหัสผ่านใหม่</label>
                <div class="form-check mb-2">
                  <input id="mct-admin-reset-auto" v-model="reset.passwordMode" class="form-check-input" type="radio" value="auto">
                  <label class="form-check-label" for="mct-admin-reset-auto">สร้างรหัสผ่านโดยอัตโนมัติ</label>
                </div>
                <div class="form-check mb-3">
                  <input id="mct-admin-reset-manual" v-model="reset.passwordMode" class="form-check-input" type="radio" value="manual">
                  <label class="form-check-label" for="mct-admin-reset-manual">กำหนดรหัสผ่านเอง</label>
                </div>
                <div v-if="reset.passwordMode === 'manual'">
                  <input v-model="reset.password" type="password" class="form-control mb-2" placeholder="รหัสผ่านใหม่" autocomplete="new-password" required>
                  <input v-model="reset.passwordConfirm" type="password" class="form-control" placeholder="ยืนยันรหัสผ่าน" autocomplete="new-password" required>
                </div>
                <p v-if="resetPasswordFeedback.text" class="form-text mb-0 mt-2" :class="'text-' + resetPasswordFeedback.tone">{{ resetPasswordFeedback.text }}</p>
                <p v-if="reset.passwordMode === 'manual'" class="form-text mb-0 mt-2">ความยาวอย่างน้อย 8 ตัวอักษร ต้องมีตัวเลข ตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก และอักขระพิเศษ</p>
                <p v-else class="form-text text-muted mb-0 mt-1">ระบบจะสร้างรหัสผ่านให้อัตโนมัติ หลังบันทึกสำเร็จจะแสดงรหัสชั่วคราวให้คัดลอกแจ้งผู้ใช้</p>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">ยกเลิก</button>
              <button type="submit" class="btn btn-warning" :disabled="resetting">{{ resetting ? "กำลังบันทึก..." : "บันทึกรหัสผ่านใหม่" }}</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="modal fade zoomIn" ref="deleteModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="mt-2 text-center">
              <h4>ยืนยันการลบผู้ใช้งาน?</h4>
              <p class="text-muted mx-4 mb-0">จะลบ {{ deleteTarget ? (deleteTarget.full_name || deleteTarget.id) : "" }} ออกจากระบบ</p>
            </div>
            <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
              <button type="button" class="btn w-sm btn-light" data-bs-dismiss="modal">Close</button>
              <button type="button" class="btn w-sm btn-danger" :disabled="deleting" @click="confirmDelete">{{ deleting ? "กำลังลบ..." : "Yes, Delete It!" }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
